/* src/pages/projects/page-projects.component.scss */
.thumbnail {
  width: 40px;
  height: 40px;
  vertical-align: top;
  background-color: var(--vwui-color-neutral-4);
  border-radius: 4px;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.thumbnail-wrapper {
  position: relative;
  padding-left: 50px;
}
.ball {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 10px;
  margin-right: 5px;
  vertical-align: middle;
}
.ball--initial {
  background: #008CBC;
}
.ball--quickscan_saved {
  background: #36B37A;
}
.ball--mandating {
  background: #FFAB01;
}
.ball--mandating_failed {
  background: var(--vwui-color-error);
}
.ball--mandating_succeeded {
  background: var(--vwui-color-primary);
}
.ball--in_execution {
  background: #0E4255;
}
.vwui-table-row--with-hover:hover {
  cursor: pointer;
  background-color: #EEF1FA;
}
.search-projects {
  width: 100%;
}
.search-company,
.search-classification,
.search-status,
.search-construction-costs {
  width: 100%;
  margin: 0 0 0 var(--vwui-size-spacing-xs);
}
.project-details--small {
  font-weight: lighter;
  font-size: smaller;
}
.project-details--place {
  max-width: 25vw;
  width: 25vw;
  word-wrap: break-word;
}
.project-details--name {
  max-width: 25vw;
  width: 25vw;
  word-wrap: break-word;
}
.project-details--city {
  max-width: 10vw;
  width: 10vw;
  word-wrap: break-word;
}
/*# sourceMappingURL=page-projects.component-PEIYVGOO.css.map */
